webpackJsonp([28],{

/***/ 1518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(1855);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6866e438_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(2137);
function injectStyle (ssrContext) {
  __webpack_require__(2125)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6866e438"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6866e438_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_DashboardTile_vue__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_DashboardTileSkeleton_vue__ = __webpack_require__(2133);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Kolejnosc odpowiada wartosci pola status z API: 0 - ok, 1 - ostrzezenie, 2 - blad, 3 - system wylaczony.
// Kolory statusow sa w tokenach --status-* (assets/css/theme.css), osobno dla motywu jasnego i ciemnego.
var STATUS_META = [{ key: 'ok', label: 'Working Fine' }, { key: 'warning', label: 'Warning' }, { key: 'error', label: 'Error' }, { key: 'down', label: 'System Down' }];

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {},
    components: {
        DashboardTile: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_DashboardTile_vue__["a" /* default */],
        DashboardTileSkeleton: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_DashboardTileSkeleton_vue__["a" /* default */]
    },
    data: function data() {
        return {
            systems: [],
            interval: null,
            isLoading: true,
            activeFilter: 'all',
            search: ''
        };
    },

    computed: {
        chips: function chips() {
            var _this = this;

            var chips = [{ key: 'all', label: 'ALL_SYSTEMS', count: this.systems.length }];

            // Od najpowazniejszego statusu, zeby problemy byly pierwsze pod reka.

            var _loop = function _loop(status) {
                var meta = STATUS_META[status];
                chips.push({
                    key: meta.key,
                    label: meta.label,
                    count: _this.systems.filter(function (x) {
                        return x.status === status;
                    }).length
                });
            };

            for (var status = STATUS_META.length - 1; status >= 0; status--) {
                _loop(status);
            }

            return chips;
        },
        visibleSystems: function visibleSystems() {
            var _this2 = this;

            var phrase = this.search.trim().toLowerCase();

            return this.systems.filter(function (x) {
                if (_this2.activeFilter !== 'all' && STATUS_META[x.status].key !== _this2.activeFilter) {
                    return false;
                }

                if (phrase !== '' && (x.name || '').toLowerCase().indexOf(phrase) === -1) {
                    return false;
                }

                return true;
            });
        }
    },
    methods: {
        setFilter: function setFilter(key) {
            this.activeFilter = key;
        },
        getData: function getData() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var result;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_75" /* getSystemStatusList */])();

                            case 2:
                                _context.t0 = _context.sent;

                                if (_context.t0) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.t0 = [];

                            case 5:
                                result = _context.t0;


                                result.forEach(function (s) {
                                    if (s.statusDescription == "System down") {
                                        s.status = 3;
                                    }

                                    if (s.status == null || STATUS_META[s.status] == null) {
                                        s.status = 0;
                                    }

                                    s.statusDescription = s.statusDescription.split(',').map(function (x) {
                                        return _this3.$t(x.trim());
                                    }).join(', ');
                                    s.lastUpdateFrom = new Date(s.lastUpdate).toAgoString();
                                });

                                _this3.systems = result.sort(_this3.doubleSorting);
                                _this3.isLoading = false;

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        doubleSorting: function doubleSorting(a, b) {
            if (a.status != b.status) {
                return b.status - a.status;
            } else {
                return a.name.localeCompare(b.name, undefined, {
                    numeric: true,
                    sensitivity: 'base'
                });
            }
        },
        intervalMethod: function intervalMethod() {
            // Odswiezanie w tle - bez szkieletu i bez globalnego spinnera, zeby widok nie migotal.
            this.getData();
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return this.getData();

                        case 2:
                            this.interval = setInterval(function () {
                                return _this4.intervalMethod();
                            }, 15000);

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }(),
    destroyed: function destroyed() {
        clearInterval(this.interval);
    }
});

/***/ }),

/***/ 1856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var STATUS_KEYS = ['ok', 'warning', 'error', 'down'];
var STATUS_LABELS = ['Working Fine', 'Warning', 'Error', 'System Down'];

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        statusKey: function statusKey() {
            return STATUS_KEYS[this.item.status] || 'ok';
        },
        statusLabel: function statusLabel() {
            return STATUS_LABELS[this.item.status] || STATUS_LABELS[0];
        },
        freeSpaceText: function freeSpaceText() {
            return this.item.freeSpace == null ? '-' : this.item.freeSpace + ' GB';
        }
    },
    methods: {
        openSystem: function openSystem() {
            this.$router.push({
                name: "settingsGeneral",
                params: {
                    systemName: this.item.name,
                    systemId: this.item.id
                }
            });
        }
    }
});

/***/ }),

/***/ 1857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DashboardTileSkeleton'
});

/***/ }),

/***/ 2125:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2126);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1528d2d4", content, true, {});

/***/ }),

/***/ 2126:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".dashboard[data-v-6866e438]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%}.dashboard__toolbar[data-v-6866e438]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:10px;margin-bottom:15px}.dashboard__filters[data-v-6866e438],.dashboard__toolbar[data-v-6866e438]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.dashboard__filters[data-v-6866e438]{gap:8px}.status-chip[data-v-6866e438]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;padding:6px 12px;border:1px solid var(--dash-border);border-radius:6px;background:var(--surface);color:var(--dash-text);cursor:pointer;-webkit-transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease,-webkit-box-shadow .15s ease}.status-chip--all[data-v-6866e438]{--chip-color:var(--dash-accent)}.status-chip--ok[data-v-6866e438]{--chip-color:var(--status-ok)}.status-chip--warning[data-v-6866e438]{--chip-color:var(--status-warning)}.status-chip--error[data-v-6866e438]{--chip-color:var(--status-error)}.status-chip--down[data-v-6866e438]{--chip-color:var(--status-down)}.status-chip[data-v-6866e438]:hover{border-color:var(--dash-border-hover)}.status-chip--active[data-v-6866e438],.status-chip--active[data-v-6866e438]:hover{border-color:var(--chip-color);-webkit-box-shadow:inset 0 -3px 0 0 var(--chip-color);box-shadow:inset 0 -3px 0 0 var(--chip-color);color:var(--dash-text-strong)}.status-chip__dot[data-v-6866e438]{width:10px;height:10px;border-radius:50%;background-color:var(--chip-color)}.status-chip__count[data-v-6866e438]{font-size:16px;font-weight:700}.status-chip__label[data-v-6866e438]{font-size:11px;text-transform:uppercase;letter-spacing:.3px;color:var(--dash-muted)}.status-chip--active .status-chip__label[data-v-6866e438]{color:var(--dash-text)}.dashboard__search[data-v-6866e438]{width:220px;padding:7px 12px;border:1px solid var(--dash-border);border-radius:6px;background:var(--surface);font-size:13px;color:var(--dash-text)}.dashboard__search[data-v-6866e438]:focus{border-color:var(--dash-accent);outline:none}.dashboard__empty[data-v-6866e438]{padding:40px 0;text-align:center;font-size:14px;color:var(--dash-muted)}.tiles[data-v-6866e438]{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:15px 20px;width:100%;-ms-flex-line-pack:start;align-content:start}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Dashboard.vue"],"names":[],"mappings":"AACA,4BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAa,CAChB,AACD,qCAMI,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,SAAU,AACV,kBAAoB,CACvB,AACD,0EAdI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,cAAgB,CAiBvB,AAPD,qCAMI,OAAS,CACZ,AAGD,8BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,QAAS,AACT,iBAAkB,AAClB,oCAAqC,AACrC,kBAAmB,AACnB,0BAA2B,AAC3B,uBAAwB,AACxB,eAAgB,AAChB,uEAA2E,AAC3E,+DAAmE,AACnE,uDAA2D,AAC3D,mFAA0F,CAC7F,AACD,mCAAqC,+BAAiC,CACrE,AACD,kCAAoC,6BAA+B,CAClE,AACD,uCAAyC,kCAAoC,CAC5E,AACD,qCAAuC,gCAAkC,CACxE,AACD,oCAAsC,+BAAiC,CACtE,AACD,oCACI,qCAAuC,CAC1C,AACD,kFAEI,+BAAgC,AAChC,sDAAuD,AAC/C,8CAA+C,AACvD,6BAA+B,CAClC,AACD,mCACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,kCAAoC,CACvC,AACD,qCACI,eAAgB,AAChB,eAAkB,CACrB,AACD,qCACI,eAAgB,AAChB,yBAA0B,AAC1B,oBAAsB,AACtB,uBAAyB,CAC5B,AACD,0DACI,sBAAwB,CAC3B,AACD,oCACI,YAAa,AACb,iBAAkB,AAClB,oCAAqC,AACrC,kBAAmB,AACnB,0BAA2B,AAC3B,eAAgB,AAChB,sBAAwB,CAC3B,AACD,0CACI,gCAAiC,AACjC,YAAc,CACjB,AACD,mCACI,eAAgB,AAChB,kBAAmB,AACnB,eAAgB,AAChB,uBAAyB,CAC5B,AACD,wBACI,aAAc,AACd,0DAA6D,AAC7D,cAAe,AACf,WAAY,AACZ,yBAA0B,AACtB,mBAAqB,CAC5B","file":"Dashboard.vue","sourcesContent":["\n.dashboard[data-v-6866e438] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    height: 100%;\n}\n.dashboard__toolbar[data-v-6866e438] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 15px;\n}\n.dashboard__filters[data-v-6866e438] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 8px;\n}\n\n/* Kolory z tokenów --status-* i --dash-* (assets/css/theme.css). */\n.status-chip[data-v-6866e438] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border: 1px solid var(--dash-border);\n    border-radius: 6px;\n    background: var(--surface);\n    color: var(--dash-text);\n    cursor: pointer;\n    -webkit-transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;\n    transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease, -webkit-box-shadow 0.15s ease;\n}\n.status-chip--all[data-v-6866e438] { --chip-color: var(--dash-accent);\n}\n.status-chip--ok[data-v-6866e438] { --chip-color: var(--status-ok);\n}\n.status-chip--warning[data-v-6866e438] { --chip-color: var(--status-warning);\n}\n.status-chip--error[data-v-6866e438] { --chip-color: var(--status-error);\n}\n.status-chip--down[data-v-6866e438] { --chip-color: var(--status-down);\n}\n.status-chip[data-v-6866e438]:hover {\n    border-color: var(--dash-border-hover);\n}\n.status-chip--active[data-v-6866e438],\n.status-chip--active[data-v-6866e438]:hover {\n    border-color: var(--chip-color);\n    -webkit-box-shadow: inset 0 -3px 0 0 var(--chip-color);\n            box-shadow: inset 0 -3px 0 0 var(--chip-color);\n    color: var(--dash-text-strong);\n}\n.status-chip__dot[data-v-6866e438] {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: var(--chip-color);\n}\n.status-chip__count[data-v-6866e438] {\n    font-size: 16px;\n    font-weight: bold;\n}\n.status-chip__label[data-v-6866e438] {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    color: var(--dash-muted);\n}\n.status-chip--active .status-chip__label[data-v-6866e438] {\n    color: var(--dash-text);\n}\n.dashboard__search[data-v-6866e438] {\n    width: 220px;\n    padding: 7px 12px;\n    border: 1px solid var(--dash-border);\n    border-radius: 6px;\n    background: var(--surface);\n    font-size: 13px;\n    color: var(--dash-text);\n}\n.dashboard__search[data-v-6866e438]:focus {\n    border-color: var(--dash-accent);\n    outline: none;\n}\n.dashboard__empty[data-v-6866e438] {\n    padding: 40px 0;\n    text-align: center;\n    font-size: 14px;\n    color: var(--dash-muted);\n}\n.tiles[data-v-6866e438] {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 15px 20px;\n    width: 100%;\n    -ms-flex-line-pack: start;\n        align-content: start;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardTile_vue__ = __webpack_require__(1856);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e794eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardTile_vue__ = __webpack_require__(2130);
function injectStyle (ssrContext) {
  __webpack_require__(2128)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42e794eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardTile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e794eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2128:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2129);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("fcbcc264", content, true, {});

/***/ }),

/***/ 2129:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tile[data-v-42e794eb]{--tile-badge-fg:var(--status-badge-fg);display:-webkit-box;display:-ms-flexbox;display:flex;min-height:118px;overflow:hidden;border-radius:6px;cursor:pointer;background:linear-gradient(100deg,var(--tile-tint),var(--surface) 75%);-webkit-box-shadow:var(--dash-shadow);box-shadow:var(--dash-shadow);-webkit-transition:-webkit-box-shadow .15s ease,-webkit-transform .15s ease;transition:-webkit-box-shadow .15s ease,-webkit-transform .15s ease;transition:box-shadow .15s ease,transform .15s ease;transition:box-shadow .15s ease,transform .15s ease,-webkit-box-shadow .15s ease,-webkit-transform .15s ease}.tile--ok[data-v-42e794eb]{--tile-color:var(--status-ok);--tile-tint:var(--status-ok-tint)}.tile--warning[data-v-42e794eb]{--tile-color:var(--status-warning);--tile-tint:var(--status-warning-tint)}.tile--error[data-v-42e794eb]{--tile-color:var(--status-error);--tile-tint:var(--status-error-tint)}.tile--down[data-v-42e794eb]{--tile-color:var(--status-down);--tile-tint:var(--status-down-tint);--tile-badge-fg:var(--status-down-badge-fg)}.tile[data-v-42e794eb]:hover{-webkit-transform:translateY(-2px);transform:translateY(-2px);-webkit-box-shadow:var(--dash-shadow-hover);box-shadow:var(--dash-shadow-hover)}.tile__accent[data-v-42e794eb]{width:7px;-webkit-box-flex:0;-ms-flex:0 0 7px;flex:0 0 7px;background-color:var(--tile-color)}.tile__body[data-v-42e794eb]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;padding:12px 16px 14px 18px}.tile__header[data-v-42e794eb]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.tile__name[data-v-42e794eb]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;font-size:20px;font-weight:700;color:var(--dash-text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tile__badge[data-v-42e794eb]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding:2px 8px;border-radius:10px;background-color:var(--tile-color);color:var(--tile-badge-fg);font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.3px;white-space:nowrap}.tile__columns[data-v-42e794eb]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:16px;margin-top:8px}.tile__column[data-v-42e794eb]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.tile__column--narrow[data-v-42e794eb]{-webkit-box-flex:0;-ms-flex:0 0 90px;flex:0 0 90px;text-align:right}.tile__label[data-v-42e794eb]{font-size:10px;color:var(--dash-muted);margin-top:4px}.tile__value[data-v-42e794eb]{font-size:14px;color:var(--dash-text);min-width:0}.tile__value--strong[data-v-42e794eb]{font-weight:700}.tile__value--ellipsis[data-v-42e794eb]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tile__value-row[data-v-42e794eb]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:4px;min-width:0}.tile__icon[data-v-42e794eb]{-webkit-filter:var(--dash-icon-filter);filter:var(--dash-icon-filter)}.tile__icon--large[data-v-42e794eb]{height:16px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Dashboard/DashboardTile.vue"],"names":[],"mappings":"AA8EA,uBACI,uCAAwC,AACxC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,iBAAkB,AAClB,gBAAiB,AACjB,kBAAmB,AACnB,eAAgB,AAChB,uEAA6E,AAC7E,sCAAuC,AAC/B,8BAA+B,AACvC,4EAAgF,AAChF,oEAAwE,AACxE,oDAAwD,AACxD,4GAAqH,CACxH,AACD,2BACI,8BAA+B,AAC/B,iCAAmC,CACtC,AACD,gCACI,mCAAoC,AACpC,sCAAwC,CAC3C,AACD,8BACI,iCAAkC,AAClC,oCAAsC,CACzC,AAGD,6BACI,gCAAiC,AACjC,oCAAqC,AACrC,2CAA6C,CAChD,AACD,6BACI,mCAAoC,AAC5B,2BAA4B,AACpC,4CAA6C,AACrC,mCAAqC,CAChD,AACD,+BACI,UAAW,AACX,mBAAoB,AAChB,iBAAkB,AACd,aAAc,AACtB,kCAAoC,CACvC,AACD,6BACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,YAAa,AACb,2BAA6B,CAChC,AACD,+BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,OAAS,CACZ,AACD,6BACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,YAAa,AACb,eAAgB,AAChB,gBAAkB,AAClB,uBAAwB,AACxB,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACvB,AACD,8BACI,mBAAoB,AAChB,kBAAmB,AACf,cAAe,AACvB,gBAAiB,AACjB,mBAAoB,AACpB,mCAAoC,AACpC,2BAA4B,AAC5B,eAAgB,AAChB,gBAAiB,AACjB,yBAA0B,AAC1B,oBAAsB,AACtB,kBAAoB,CACvB,AACD,gCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,SAAU,AACV,cAAgB,CACnB,AACD,+BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,WAAa,CAChB,AACD,uCACI,mBAAoB,AAChB,kBAAmB,AACf,cAAe,AACvB,gBAAkB,CACrB,AACD,8BACI,eAAgB,AAChB,wBAAyB,AACzB,cAAgB,CACnB,AACD,8BACI,eAAgB,AAChB,uBAAwB,AACxB,WAAa,CAChB,AACD,sCACI,eAAkB,CACrB,AACD,wCACI,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACvB,AACD,kCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,QAAS,AACT,WAAa,CAChB,AACD,6BACI,uCAAwC,AAChC,8BAAgC,CAC3C,AACD,oCACI,WAAa,CAChB","file":"DashboardTile.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Kolory z tokenów --status-* i --dash-* (assets/css/theme.css), więc kafelek\n   sam dostosowuje się do motywu jasnego i ciemnego. */\n.tile[data-v-42e794eb] {\n    --tile-badge-fg: var(--status-badge-fg);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    min-height: 118px;\n    overflow: hidden;\n    border-radius: 6px;\n    cursor: pointer;\n    background: linear-gradient(100deg, var(--tile-tint) 0%, var(--surface) 75%);\n    -webkit-box-shadow: var(--dash-shadow);\n            box-shadow: var(--dash-shadow);\n    -webkit-transition: -webkit-box-shadow 0.15s ease, -webkit-transform 0.15s ease;\n    transition: -webkit-box-shadow 0.15s ease, -webkit-transform 0.15s ease;\n    transition: box-shadow 0.15s ease, transform 0.15s ease;\n    transition: box-shadow 0.15s ease, transform 0.15s ease, -webkit-box-shadow 0.15s ease, -webkit-transform 0.15s ease;\n}\n.tile--ok[data-v-42e794eb] {\n    --tile-color: var(--status-ok);\n    --tile-tint: var(--status-ok-tint);\n}\n.tile--warning[data-v-42e794eb] {\n    --tile-color: var(--status-warning);\n    --tile-tint: var(--status-warning-tint);\n}\n.tile--error[data-v-42e794eb] {\n    --tile-color: var(--status-error);\n    --tile-tint: var(--status-error-tint);\n}\n\n/* Systemy wyłączone mają ciemny akcent — w trybie jasnym na nim biały tekst. */\n.tile--down[data-v-42e794eb] {\n    --tile-color: var(--status-down);\n    --tile-tint: var(--status-down-tint);\n    --tile-badge-fg: var(--status-down-badge-fg);\n}\n.tile[data-v-42e794eb]:hover {\n    -webkit-transform: translateY(-2px);\n            transform: translateY(-2px);\n    -webkit-box-shadow: var(--dash-shadow-hover);\n            box-shadow: var(--dash-shadow-hover);\n}\n.tile__accent[data-v-42e794eb] {\n    width: 7px;\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 7px;\n            flex: 0 0 7px;\n    background-color: var(--tile-color);\n}\n.tile__body[data-v-42e794eb] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n    padding: 12px 16px 14px 18px;\n}\n.tile__header[data-v-42e794eb] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 8px;\n}\n.tile__name[data-v-42e794eb] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n    font-size: 20px;\n    font-weight: bold;\n    color: var(--dash-text);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.tile__badge[data-v-42e794eb] {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    padding: 2px 8px;\n    border-radius: 10px;\n    background-color: var(--tile-color);\n    color: var(--tile-badge-fg);\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    white-space: nowrap;\n}\n.tile__columns[data-v-42e794eb] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 16px;\n    margin-top: 8px;\n}\n.tile__column[data-v-42e794eb] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n}\n.tile__column--narrow[data-v-42e794eb] {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 90px;\n            flex: 0 0 90px;\n    text-align: right;\n}\n.tile__label[data-v-42e794eb] {\n    font-size: 10px;\n    color: var(--dash-muted);\n    margin-top: 4px;\n}\n.tile__value[data-v-42e794eb] {\n    font-size: 14px;\n    color: var(--dash-text);\n    min-width: 0;\n}\n.tile__value--strong[data-v-42e794eb] {\n    font-weight: bold;\n}\n.tile__value--ellipsis[data-v-42e794eb] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.tile__value-row[data-v-42e794eb] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 4px;\n    min-width: 0;\n}\n.tile__icon[data-v-42e794eb] {\n    -webkit-filter: var(--dash-icon-filter);\n            filter: var(--dash-icon-filter);\n}\n.tile__icon--large[data-v-42e794eb] {\n    height: 16px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile",class:'tile--' + _vm.statusKey,on:{"click":function($event){return _vm.openSystem()}}},[_c('div',{staticClass:"tile__accent"}),_vm._v(" "),_c('div',{staticClass:"tile__body"},[_c('div',{staticClass:"tile__header"},[_c('span',{staticClass:"tile__name",attrs:{"title":_vm.item.name}},[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('span',{staticClass:"tile__badge"},[_vm._v(_vm._s(_vm.$t(_vm.statusLabel)))])]),_vm._v(" "),_c('div',{staticClass:"tile__columns"},[_c('div',{staticClass:"tile__column"},[_c('span',{staticClass:"tile__label"},[_vm._v(_vm._s(_vm.$t('LastUpdate')))]),_vm._v(" "),_c('div',{staticClass:"tile__value-row"},[_c('img',{staticClass:"tile__icon",attrs:{"src":__webpack_require__(2131),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"tile__value tile__value--strong"},[_vm._v(_vm._s(_vm.item.lastUpdateFrom))])]),_vm._v(" "),_c('span',{staticClass:"tile__label"},[_vm._v(_vm._s(_vm.$t('SystemStatus')))]),_vm._v(" "),_c('div',{staticClass:"tile__value-row"},[_c('img',{staticClass:"tile__icon tile__icon--large",attrs:{"src":__webpack_require__(2132),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"tile__value tile__value--strong tile__value--ellipsis",attrs:{"title":_vm.item.statusDescription}},[_vm._v(_vm._s(_vm.item.statusDescription))])])]),_vm._v(" "),_c('div',{staticClass:"tile__column tile__column--narrow"},[_c('span',{staticClass:"tile__label"},[_vm._v(_vm._s(_vm.$t('CPUTemperature')))]),_vm._v(" "),_c('span',{staticClass:"tile__value"},[_vm._v(_vm._s(_vm.item.temperature)+"°C")]),_vm._v(" "),_c('span',{staticClass:"tile__label"},[_vm._v(_vm._s(_vm.$t('FreeSpace')))]),_vm._v(" "),_c('span',{staticClass:"tile__value"},[_vm._v(_vm._s(_vm.freeSpaceText))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2131:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTZDMy41ODg5OCAxNiAwIDEyLjQxMSAwIDhDMCAzLjU4ODk4IDMuNTg4OTggMCA4IDBDMTIuNDExIDAgMTYgMy41ODg5OCAxNiA4QzE2IDEyLjQxMSAxMi40MTEgMTYgOCAxNlpNOCAxLjA2NjY3QzQuMTc3MDcgMS4wNjY2NyAxLjA2NjY3IDQuMTc3MDcgMS4wNjY2NyA4QzEuMDY2NjcgMTEuODIyOSA0LjE3NzA3IDE0LjkzMzMgOCAxNC45MzMzQzExLjgyMjkgMTQuOTMzMyAxNC45MzMzIDExLjgyMjkgMTQuOTMzMyA4QzE0LjkzMzMgNC4xNzcwNyAxMS44MjI5IDEuMDY2NjcgOCAxLjA2NjY3WiIgZmlsbD0iIzVCNUM2MCIvPgo8cGF0aCBkPSJNMTEuMzMzMSAxMS44NjcxQzExLjI2MzEgMTEuODY3MyAxMS4xOTM3IDExLjg1MzYgMTEuMTI5IDExLjgyNjdDMTEuMDY0MyAxMS43OTk4IDExLjAwNTYgMTEuNzYwNCAxMC45NTYyIDExLjcxMDZMNy42MjMyNiA4LjM3Njk0QzcuNTczMzUgOC4zMjcyMSA3LjUzMzk0IDguMjY3OTYgNy41MDczNSA4LjIwMjcyTDcuNTAwOTUgOC4xODQ5NEM3LjQ3ODc2IDguMTI1ODIgNy40Njc0NCA4LjA2MzE5IDcuNDY3NTMgOC4wMDAwNVY1LjMzMzM4QzcuNDY3NTMgNS4xOTE5MyA3LjUyMzcyIDUuMDU2MjggNy42MjM3NCA0Ljk1NjI2QzcuNzIzNzYgNC44NTYyNCA3Ljg1OTQxIDQuODAwMDUgOC4wMDA4NiA0LjgwMDA1QzguMTQyMzEgNC44MDAwNSA4LjI3Nzk3IDQuODU2MjQgOC4zNzc5OSA0Ljk1NjI2QzguNDc4MDEgNS4wNTYyOCA4LjUzNDIgNS4xOTE5MyA4LjUzNDIgNS4zMzMzOFY3Ljc3ODg5TDExLjcxMDcgMTAuOTU2MUMxMS43NjA3IDExLjAwNTQgMTEuODAwNCAxMS4wNjQgMTEuODI3NSAxMS4xMjg3QzExLjg1NDUgMTEuMTkzNCAxMS44Njg1IDExLjI2MjkgMTEuODY4NSAxMS4zMzNDMTEuODY4NSAxMS40MDMyIDExLjg1NDUgMTEuNDcyNiAxMS44Mjc1IDExLjUzNzNDMTEuODAwNCAxMS42MDIgMTEuNzYwNyAxMS42NjA3IDExLjcxMDcgMTEuNzA5OUMxMS42MTA3IDExLjgxMDMgMTEuNDc0OCAxMS44NjY4IDExLjMzMzEgMTEuODY3MVoiIGZpbGw9IiM1QjVDNjAiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 2132:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMDQwMjggOC43MTk5N0gxNy4xMjAzIiBzdHJva2U9IiM1QjVDNjAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy4wNDAyOCAxMi45MkgxNy4xMjAzIiBzdHJva2U9IiM1QjVDNjAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy4wNDAyOCAxNy4xMkgxNy4xMjAzIiBzdHJva2U9IiM1QjVDNjAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy4wNCAySDIwLjQ4QzIwLjkyNTYgMiAyMS4zNTI5IDIuMTc3IDIxLjY2NzkgMi40OTIwNkMyMS45ODMgMi44MDcxMiAyMi4xNiAzLjIzNDQ0IDIyLjE2IDMuNjhWMjEuMzJDMjIuMTYgMjEuNzY1NiAyMS45ODMgMjIuMTkyOSAyMS42Njc5IDIyLjUwNzlDMjEuMzUyOSAyMi44MjMgMjAuOTI1NiAyMyAyMC40OCAyM0gzLjY4QzMuMjM0NDQgMjMgMi44MDcxMiAyMi44MjMgMi40OTIwNiAyMi41MDc5QzIuMTc3IDIyLjE5MjkgMiAyMS43NjU2IDIgMjEuMzJWMy42OEMyIDMuMjM0NDQgMi4xNzcgMi44MDcxMiAyLjQ5MjA2IDIuNDkyMDZDMi44MDcxMiAyLjE3NyAzLjIzNDQ0IDIgMy42OCAySDcuODgiIHN0cm9rZT0iIzVCNUM2MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 2133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardTileSkeleton_vue__ = __webpack_require__(1857);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208bb304_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardTileSkeleton_vue__ = __webpack_require__(2136);
function injectStyle (ssrContext) {
  __webpack_require__(2134)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-208bb304"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardTileSkeleton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208bb304_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardTileSkeleton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2134:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("2fe6a579", content, true, {});

/***/ }),

/***/ 2135:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tile-skeleton[data-v-208bb304]{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:118px;overflow:hidden;border-radius:6px;background:var(--surface);-webkit-box-shadow:var(--dash-shadow);box-shadow:var(--dash-shadow)}.tile-skeleton__accent[data-v-208bb304]{width:7px;-webkit-box-flex:0;-ms-flex:0 0 7px;flex:0 0 7px;background:var(--skeleton-accent)}.tile-skeleton__body[data-v-208bb304]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;padding:12px 16px 14px 18px}.tile-skeleton__columns[data-v-208bb304]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:16px;margin-top:12px}.tile-skeleton__column[data-v-208bb304]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.tile-skeleton__column--narrow[data-v-208bb304]{-webkit-box-flex:0;-ms-flex:0 0 90px;flex:0 0 90px}.tile-skeleton__line[data-v-208bb304]{border-radius:4px;background:-webkit-gradient(linear,left top,right top,color-stop(25%,var(--skeleton)),color-stop(37%,var(--skeleton-shine)),color-stop(63%,var(--skeleton)));background:linear-gradient(90deg,var(--skeleton) 25%,var(--skeleton-shine) 37%,var(--skeleton) 63%);background-size:400% 100%;-webkit-animation:tile-skeleton-loading-data-v-208bb304 1.4s ease infinite;animation:tile-skeleton-loading-data-v-208bb304 1.4s ease infinite}.tile-skeleton__line--title[data-v-208bb304]{height:20px;width:65%}.tile-skeleton__line--label[data-v-208bb304]{height:8px;width:45%;margin-bottom:5px}.tile-skeleton__line--value[data-v-208bb304]{height:12px;width:75%;margin-bottom:12px}.tile-skeleton__column--narrow .tile-skeleton__line--label[data-v-208bb304],.tile-skeleton__column--narrow .tile-skeleton__line--value[data-v-208bb304]{margin-left:auto}@-webkit-keyframes tile-skeleton-loading-data-v-208bb304{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes tile-skeleton-loading-data-v-208bb304{0%{background-position:100% 50%}to{background-position:0 50%}}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Dashboard/DashboardTileSkeleton.vue"],"names":[],"mappings":"AACA,gCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,iBAAkB,AAClB,gBAAiB,AACjB,kBAAmB,AACnB,0BAA2B,AAC3B,sCAAuC,AAC/B,6BAA+B,CAC1C,AACD,wCACI,UAAW,AACX,mBAAoB,AAChB,iBAAkB,AACd,aAAc,AACtB,iCAAmC,CACtC,AACD,sCACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,YAAa,AACb,2BAA6B,CAChC,AACD,yCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,SAAU,AACV,eAAiB,CACpB,AACD,wCACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,WAAa,CAChB,AACD,gDACI,mBAAoB,AAChB,kBAAmB,AACf,aAAe,CAC1B,AACD,sCACI,kBAAmB,AACnB,6JAAsK,AACtK,oGAAwG,AACxG,0BAA2B,AAC3B,2EAA4E,AACpE,kEAAoE,CAC/E,AACD,6CACI,YAAa,AACb,SAAW,CACd,AACD,6CACI,WAAY,AACZ,UAAW,AACX,iBAAmB,CACtB,AACD,6CACI,YAAa,AACb,UAAW,AACX,kBAAoB,CACvB,AACD,wJAEI,gBAAkB,CACrB,AACD,yDACA,GAAK,4BAA8B,CAClC,AACD,GAAO,yBAA2B,CACjC,CACA,AACD,iDACA,GAAK,4BAA8B,CAClC,AACD,GAAO,yBAA2B,CACjC,CACA","file":"DashboardTileSkeleton.vue","sourcesContent":["\n.tile-skeleton[data-v-208bb304] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    min-height: 118px;\n    overflow: hidden;\n    border-radius: 6px;\n    background: var(--surface);\n    -webkit-box-shadow: var(--dash-shadow);\n            box-shadow: var(--dash-shadow);\n}\n.tile-skeleton__accent[data-v-208bb304] {\n    width: 7px;\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 7px;\n            flex: 0 0 7px;\n    background: var(--skeleton-accent);\n}\n.tile-skeleton__body[data-v-208bb304] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n    padding: 12px 16px 14px 18px;\n}\n.tile-skeleton__columns[data-v-208bb304] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 16px;\n    margin-top: 12px;\n}\n.tile-skeleton__column[data-v-208bb304] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n}\n.tile-skeleton__column--narrow[data-v-208bb304] {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 90px;\n            flex: 0 0 90px;\n}\n.tile-skeleton__line[data-v-208bb304] {\n    border-radius: 4px;\n    background: -webkit-gradient(linear, left top, right top, color-stop(25%, var(--skeleton)), color-stop(37%, var(--skeleton-shine)), color-stop(63%, var(--skeleton)));\n    background: linear-gradient(90deg, var(--skeleton) 25%, var(--skeleton-shine) 37%, var(--skeleton) 63%);\n    background-size: 400% 100%;\n    -webkit-animation: tile-skeleton-loading-data-v-208bb304 1.4s ease infinite;\n            animation: tile-skeleton-loading-data-v-208bb304 1.4s ease infinite;\n}\n.tile-skeleton__line--title[data-v-208bb304] {\n    height: 20px;\n    width: 65%;\n}\n.tile-skeleton__line--label[data-v-208bb304] {\n    height: 8px;\n    width: 45%;\n    margin-bottom: 5px;\n}\n.tile-skeleton__line--value[data-v-208bb304] {\n    height: 12px;\n    width: 75%;\n    margin-bottom: 12px;\n}\n.tile-skeleton__column--narrow .tile-skeleton__line--label[data-v-208bb304],\n.tile-skeleton__column--narrow .tile-skeleton__line--value[data-v-208bb304] {\n    margin-left: auto;\n}\n@-webkit-keyframes tile-skeleton-loading-data-v-208bb304 {\n0% { background-position: 100% 50%;\n}\n100% { background-position: 0 50%;\n}\n}\n@keyframes tile-skeleton-loading-data-v-208bb304 {\n0% { background-position: 100% 50%;\n}\n100% { background-position: 0 50%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile-skeleton"},[_c('div',{staticClass:"tile-skeleton__accent"}),_vm._v(" "),_c('div',{staticClass:"tile-skeleton__body"},[_c('div',{staticClass:"tile-skeleton__line tile-skeleton__line--title"}),_vm._v(" "),_c('div',{staticClass:"tile-skeleton__columns"},[_c('div',{staticClass:"tile-skeleton__column"},[_c('div',{staticClass:"tile-skeleton__line tile-skeleton__line--label"}),_vm._v(" "),_c('div',{staticClass:"tile-skeleton__line tile-skeleton__line--value"}),_vm._v(" "),_c('div',{staticClass:"tile-skeleton__line tile-skeleton__line--label"}),_vm._v(" "),_c('div',{staticClass:"tile-skeleton__line tile-skeleton__line--value"})]),_vm._v(" "),_c('div',{staticClass:"tile-skeleton__column tile-skeleton__column--narrow"},[_c('div',{staticClass:"tile-skeleton__line tile-skeleton__line--label"}),_vm._v(" "),_c('div',{staticClass:"tile-skeleton__line tile-skeleton__line--value"}),_vm._v(" "),_c('div',{staticClass:"tile-skeleton__line tile-skeleton__line--label"}),_vm._v(" "),_c('div',{staticClass:"tile-skeleton__line tile-skeleton__line--value"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"dashboard__toolbar"},[_c('div',{staticClass:"dashboard__filters"},_vm._l((_vm.chips),function(chip){return _c('button',{key:chip.key,staticClass:"status-chip",class:['status-chip--' + chip.key, { 'status-chip--active': _vm.activeFilter === chip.key }],attrs:{"type":"button"},on:{"click":function($event){return _vm.setFilter(chip.key)}}},[_c('span',{staticClass:"status-chip__dot"}),_vm._v(" "),_c('span',{staticClass:"status-chip__count"},[_vm._v(_vm._s(chip.count))]),_vm._v(" "),_c('span',{staticClass:"status-chip__label"},[_vm._v(_vm._s(_vm.$t(chip.label)))])])}),0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"dashboard__search",attrs:{"type":"text","placeholder":_vm.$t('SearchSystem')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"tiles"},_vm._l((12),function(n){return _c('DashboardTileSkeleton',{key:'skeleton-' + n})}),1):(_vm.visibleSystems.length === 0)?_c('div',{staticClass:"dashboard__empty"},[_vm._v("\n            "+_vm._s(_vm.$t('NoSystemsToShow'))+"\n        ")]):_c('div',{staticClass:"tiles"},_vm._l((_vm.visibleSystems),function(item){return _c('DashboardTile',{key:item.id,attrs:{"item":item}})}),1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/28.94949c479625ac9d26c1.js